import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ITagIcon, ItemComponent, ListDetailComponent } from '@tecalisdev/infinity';
import { BOOLEAN_STATUS } from '../../../../../processes/models/processes.models';

@Component({
	selector: 'app-item-check-fraud-face-block',
	imports: [TranslatePipe, ItemComponent, ListDetailComponent],
	templateUrl: './item-check-fraud-face-block.component.html',
	styleUrl: './item-check-fraud-face-block.component.scss',
})
export class ItemCheckFraudFaceBlockComponent {
	@Input() status: BOOLEAN_STATUS | string;
	@Input() locks?: { blocked_faces?: unknown[] };

	public tagIcon?: ITagIcon;

	ngOnInit(): void {
		this.tagIcon = this.getTagIconItem(this.status);
	}

	public getTagIconItem(status: BOOLEAN_STATUS | string): ITagIcon {
		return status === 'OK'
			? { icon: 'icon-check', status: 'success', size: 'sm' }
			: { icon: 'icon-alert', status: 'error', size: 'sm' };
	}
}
